import Vue from "vue";
import Vuex from "vuex";
import logs from "./modules/logs";
import timesheet from "./modules/timesheet";
import user from "./modules/user";
import application from "./modules/application";
import report from "./modules/report";
import explanation from "./modules/explanation";
import settings from "./modules/settings";
import abnormalcase from "./modules/abnormalcase";
import request from "./modules/request";
import delegation from "./modules/delegation";
import checkinout from "./modules/checkinout";
import overtime from "./modules/overtime";
import employee from "./modules/employee";
import jobinfo from "./modules/jobinfo";
import payroll from "./modules/payroll";
import configuration from "./modules/configuration";
import specialExplanation from "./modules/specialExplanation";
import annualLeave from "./modules/annualLeave/annualLeave";
import projectLeave from "./modules/projectLeave";
import filters from "./modules/filters";

//#region annual leave
import bonusLeave from "./modules/annualLeave/bonusLeave/bonusLeave";
import generalConfiguration from "./modules/annualLeave/generalConfiguration/generalConfiguration";
import leaveCarryover from "./modules/annualLeave/leaveCarryover";
import advance from "./modules/advance";
//#endregion

// #region policy management
import policyManagementEmployee from "./modules/PolicySettings/policyManagementEmployee";
import policyConfig from "./modules/PolicySettings/policyConfig";
// #endregion

Vue.use(Vuex);
// const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  modules: {
    logs,
    timesheet,
    user,
    application,
    report,
    explanation,
    settings,
    overtime,
    abnormalcase,
    request,
    delegation,
    checkinout,
    employee,
    payroll,
    jobinfo,
    configuration,
    specialExplanation,
    filters,
    annualLeave,
    bonusLeave,
    generalConfiguration,
    leaveCarryover,
    projectLeave,
    advance,
    policyManagementEmployee,
    policyConfig,
  },
  strict: false,
});
